import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('DailyBonusRow').create(({ theme }) => ({
  root: {
    display: 'flex',
    position: 'relative',
    justifyContent: 'center',
    width: '100%',
    height: '143px',
    borderTop: '1px solid rgba(255, 255, 255, 0.2)',
    borderBottom: '1px solid black',
    pointerEvents: 'none',
    '&[data-isfaded="true"]': {
      opacity: '0.5',
    },
  },

  dailyBonusWrapperContainer: {
    display: 'flex',
    pointerEvents: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50%',

    '&[data-daystatus="current"]': {
      backgroundImage: 'linear-gradient(90deg, #1D587E 0%, #18273A 100%)',
    },
    '&[data-daystatus="gray"]': {
      backgroundImage: 'linear-gradient(90deg,rgba(76, 76, 76, 0.34) 0%,rgb(48, 48, 48) 100%)',
    },
    '&[data-inactive="false"]': {
      backgroundImage: 'radial-gradient(circle,rgb(19, 113, 175) 0%, #1D1E22 80%)',
    },
    '&[data-inactive="true"]': {
      backgroundImage: 'radial-gradient(circle,rgb(124, 124, 124) 0%, #1D1E22 80%)',
    },

    '&[data-daystatus="previous"]': {
      background: 'rgba(24, 39, 58, 1)',
    },
  },

  basicBonusWrapperContainer: {
    display: 'flex',
    pointerEvents: 'auto',
    justifyContent: 'center',
    alignItems: 'center',
    width: '50%',
    '&[data-daystatus="current"]': {
      backgroundImage: 'linear-gradient(90deg, #1D587E)',
    },
  },

  separatorWrapper: {
    position: 'absolute',
    height: '143px',
    zIndex: 4,
    // position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  separatorLine: {
    position: 'relative',
    zIndex: 2,
    width: '8px',
    height: '45%',
    background: theme.colors.background.primary,
    border: '1px solid black',
    borderTop: 'none',
    borderBottom: 'none',
  },

  daysLabel: {
    position: 'relative',
    zIndex: '1',
    marginTop: '-1px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '48px',
    height: '36px',
    background: theme.colors.background.primary,
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.2), 0px 1px 0px 0px rgba(0, 0, 0, 1) inset',
    borderRadius: '24px',
    span: {
      fontSize: '12px',
      lineHeight: theme.sizes.texts.lineHeight.l,
      color: theme.colors.text.primary,

      fontWeight: 460,
    },
  },
}))
